<template>
  <a-modal
    :visible="open"
    :title="modalTitle"
    :confirmLoading="submitLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
    width="600px"
    :destroyOnClose="true"
  >
    <a-alert type="info" show-icon style="margin-bottom: 16px;">
      <template slot="message">
        <div>请按照下方模板格式准备Excel文件：</div>
        <div style="margin-top: 8px;">
          <a-button type="link" size="small" icon="download" @click="downloadTemplate">下载导入模板</a-button>
        </div>
        <div style="margin-top: 8px; font-size: 12px; color: #666;">
          模板包含列：手机号、姓名、邮箱、性别
        </div>
      </template>
    </a-alert>

    <a-upload-dragger
      :beforeUpload="beforeUpload"
      :fileList="fileList"
      :remove="handleRemove"
      accept=".xls,.xlsx"
    >
      <p class="ant-upload-drag-icon">
        <a-icon type="inbox" />
      </p>
      <p class="ant-upload-text">点击或拖拽文件到此区域上传</p>
      <p class="ant-upload-hint">支持 .xls、.xlsx 格式的Excel文件</p>
    </a-upload-dragger>

    <div v-if="importResult" style="margin-top: 16px;">
      <a-alert :type="importResult.errors && importResult.errors.length > 0 ? 'warning' : 'success'" show-icon>
        <template slot="message">
          <div>导入完成！共 {{ importResult.total }} 条数据</div>
          <div>成功：{{ importResult.success }} 条，跳过（已存在）：{{ importResult.skip }} 条</div>
          <div v-if="importResult.errors && importResult.errors.length > 0">
            失败：{{ importResult.errors.length }} 条
            <a @click="showErrors = !showErrors" style="margin-left: 8px;">
              {{ showErrors ? '收起详情' : '展开详情' }}
            </a>
          </div>
        </template>
      </a-alert>
    </div>

    <template slot="footer">
      <a-button key="back" @click="handleCancel">取消</a-button>
      <a-button key="submit" type="primary" :loading="submitLoading" @click="handleSubmit" :disabled="!uploadFile">
        开始导入
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import { importUser } from '@/api/biz/user'
import { getToken } from '@/utils/auth'

export default {
  name: 'ImportModal',
  data() {
    return {
      open: false,
      submitLoading: false,
      uploadFile: null,
      fileList: [],
      importResult: null,
      showErrors: false,
      uploadUrl: process.env.VUE_APP_BASE_API + '/biz/user/import',
      modalTitle: '批量导入员工'
    }
  },
  methods: {
    openModal() {
      this.open = true
      this.fileList = []
      this.uploadFile = null
      this.importResult = null
      this.showErrors = false
    },
    beforeUpload(file) {
      const isExcel = file.name.endsWith('.xls') || file.name.endsWith('.xlsx')
      if (!isExcel) {
        this.$message.error('只能上传 .xls 或 .xlsx 格式的Excel文件！')
        return false
      }
      this.uploadFile = file
      this.fileList = [file]
      return false
    },
    handleRemove() {
      this.uploadFile = null
      this.fileList = []
      this.importResult = null
    },
    async downloadTemplate() {
      try {
        const response = await fetch(process.env.VUE_APP_BASE_API + '/biz/user/import/template', {
          method: 'POST',
          headers: { 'Authorization': 'Bearer ' + getToken() }
        })
        const blob = await response.blob()
        const link = document.createElement('a')
        const url = URL.createObjectURL(blob)
        link.setAttribute('href', url)
        link.setAttribute('download', '员工导入模板.xlsx')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
      } catch (e) {
        this.$message.error('下载模板失败')
      }
    },
    handleSubmit() {
      if (!this.uploadFile) {
        this.$message.warning('请先上传Excel文件')
        return
      }
      this.submitLoading = true
      const formData = new FormData()
      formData.append('file', this.uploadFile)

      const xhr = new XMLHttpRequest()
      xhr.open('POST', this.uploadUrl, true)
      xhr.setRequestHeader('Authorization', 'Bearer ' + getToken())
      xhr.onload = () => {
        this.submitLoading = false
        if (xhr.status === 200) {
          const response = JSON.parse(xhr.responseText)
          if (response.success) {
            this.importResult = response.data
            this.$emit('ok')
          } else {
            this.$message.error(response.msg || '导入失败')
          }
        } else {
          this.$message.error('导入失败，请重试')
        }
      }
      xhr.onerror = () => {
        this.submitLoading = false
        this.$message.error('网络错误，导入失败')
      }
      xhr.send(formData)
    },
    handleCancel() {
      this.open = false
      this.uploadFile = null
      this.fileList = []
      this.importResult = null
      this.showErrors = false
    }
  }
}
</script>
